const GibraltarSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111489)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F9F9F9"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9299 34.573 38.7557 26.957H1.24365C4.06959 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="#D80027"
      />
      <path
        d="M27.8264 16.5212V13.9125H28.6959V12.1734H26.9568V13.043H25.2177V12.1734H23.4786V13.9125H24.3481V16.5212H22.609V10.4344H23.4786V8.69531H21.7394V9.56469H20.8698V8.69531H19.1308V9.56469H18.2612V8.69531H16.522V10.4344H17.3916V16.5212H15.6525V13.9125H16.522V12.1734H14.7829V13.043H13.0438V12.1734H11.3047V13.9125H12.1742V16.5212H10.4351V23.4777H29.5655V16.5212H27.8264Z"
        fill="#D80027"
      />
      <path
        d="M19.9997 22.6084C18.559 22.6084 17.391 23.7764 17.391 25.2171C17.391 26.3527 18.1171 27.3186 19.1302 27.6768V31.3041H16.5215V34.7824H20.8693V27.6768C21.8823 27.3187 22.6084 26.3529 22.6084 25.2171C22.6084 23.7764 21.4404 22.6084 19.9997 22.6084ZM19.9997 26.0867C19.5195 26.0867 19.1302 25.6973 19.1302 25.2171C19.1302 24.7369 19.5195 24.3476 19.9997 24.3476C20.4799 24.3476 20.8692 24.7369 20.8692 25.2171C20.8692 25.6973 20.4799 26.0867 19.9997 26.0867Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111489">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GibraltarSvg;
